import { useCallback } from 'react';
import { getCampBulkWizardTourSteps } from '@/lib/tours/camp-bulk-wizard-tour-steps';
import { getCampBulkWizardStepCompletionKey } from '@/lib/tours/campBulkWizardTour';
import { usePageTourActions } from './PageTourHost';

export function useCampBulkWizardStepTour(wizardStep: number) {
  const { startTourWithCompletionKey } = usePageTourActions();

  return useCallback(() => {
    startTourWithCompletionKey(
      getCampBulkWizardStepCompletionKey(wizardStep),
      getCampBulkWizardTourSteps(wizardStep),
    );
  }, [startTourWithCompletionKey, wizardStep]);
}
